export enum SideMenuEnum {
  BusinessOverview = 'BusinessOverview',
  Admininstration = 'Admininstration',
  TradingHub = 'TradingHub'
}
